import CryptoJS from "crypto-js";

// Your encryption key
const encryptionKey = "your-very-secure-key-aes-256"; // Ensure this is kept safe and secure

/**
 * Function to encrypt an object
 * @param obj
 * @return {*}
 */
function encryptObject(obj) {
  // Convert the object to a string
  const stringifiedObj = JSON.stringify(obj);

  // Encrypt the stringifies object
  return CryptoJS.AES.encrypt(stringifiedObj, encryptionKey).toString();
}

/**
 * Function to decrypt the encrypted object
 * @param encrypted
 * @return {any}
 */
function decryptObject(encrypted) {
  // Decrypt the encrypted string
  const bytes = CryptoJS.AES.decrypt(encrypted, encryptionKey);

  // Convert the decrypted string back to a JSON object
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);

  return JSON.parse(decryptedString);
}

export { encryptObject, decryptObject };
